/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Usage_Active_UntilInputs */

const en_settings_usage_active_until = /** @type {(inputs: Settings_Usage_Active_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Active — valid until ${i?.date}`)
};

const id_settings_usage_active_until = /** @type {(inputs: Settings_Usage_Active_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktif — berlaku hingga ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Active — valid until {date}" |
*
* @param {Settings_Usage_Active_UntilInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_usage_active_until = /** @type {((inputs: Settings_Usage_Active_UntilInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Usage_Active_UntilInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_usage_active_until(inputs)
	return en_settings_usage_active_until(inputs)
});